import { useState, useEffect } from 'react';
import axios from '../api/api';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Utilization = () => {

  const CurrentYear = new Date().getFullYear();
  const CurrentMonth = new Date().getMonth() + 1; 
  const CurrentDay = new Date().getDate();

  const lastDayOfMonth = new Date(CurrentYear, CurrentMonth, 0).getDate();
  const yearStr = CurrentYear.toString();
  const monthStr = CurrentMonth.toString().padStart(2, '0');
  const dayStr = CurrentDay.toString().padStart(2, '0'); 


  const startDate = `${yearStr}-${monthStr}-01`;
  const endDate = `${yearStr}-${monthStr}-${lastDayOfMonth.toString().padStart(2, '0')}`;
  const startMonth = `${yearStr}-01-01`;
  const endMonth = `${yearStr}-12-${lastDayOfMonth.toString().padStart(2, '0')}`;
  const startHour = `${yearStr}-${monthStr}-${dayStr}`;
  const endHour = `${yearStr}-${monthStr}-${dayStr}`;


  const [dayStats, setDayStats] = useState([]);
  const [monthStats, setMonthStats] = useState([]);
  const [hourStats, setHourStats] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(startDate);
  const [endDateFilter, setEndDateFilter] = useState(endDate);

  const handleStartDateChange = (e) => {
    setStartDateFilter(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDateFilter(e.target.value);
  };

  // day
  useEffect(() => {
    const fetchDayData = async () => {
      try {
        const response = await axios.get(`/stats/?type=total_day_sales&start_date=${startDateFilter}&end_date=${endDateFilter}`);
        setDayStats(response.data.items);
      } catch (error) {
        console.error(error);
      }
    };
    fetchDayData();
  }, [startDateFilter, endDateFilter]);

  // month
  useEffect(() => {
    const fetchMonthData = async () => {
      try {
        const response = await axios.get(`/stats/?type=total_month_sales&start_date=${startMonth}&end_date=${endMonth}`);
        setMonthStats(response.data.items);
      } catch (error) {
        console.error(error);
      }
    };
    fetchMonthData();
  }, [startMonth,endMonth]);

  // hour
  useEffect(() => {
    const fetchHourData = async () => {
      try {
        const response = await axios.get(`/stats/?type=total_hour_sales&start_date=${startHour}&end_date=${endHour}`);
        setHourStats(response.data.items);
      } catch (error) {
        console.error(error);
      }
    };
    fetchHourData();
  }, [startHour,endHour]);
  

  return (
    <div className='mx-auto p-4'>
      <div className='flex flex-wrap items-center justify-between'>
        <h1 className='text-xl font-bold'>Airtime & Data Utilization</h1>
        <form className='flex gap-2 w-full md:w-1/2 xl:w-1/3'>
          <div className='w-full'>
            <label htmlFor='startdate'>From Date
              <input
                type='date'
                required
                className='px-3 py-1.5 bg-inherit border-2 shadow-sm border-[#165277] placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                value={startDateFilter}
                onChange={handleStartDateChange}
              />
            </label>
          </div>
          <div className='w-full'>
            <label htmlFor='enddate'>To Date
              <input
                type='date'
                required
                className='px-3 py-1.5 bg-inherit border-2 shadow-sm border-[#165277] placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                value={endDateFilter}
                onChange={handleEndDateChange}
              />
            </label>
          </div>
        </form>
      </div>
      <div className="grid grid-cols-1 gap-4 my-4 md:grid-cols-2 lg:grid-cols-3">
        <div className='bg-white p-4 rounded-md'>
          <p>TOTAL HOURLY CONSUMPTION</p>
          <span className='text-yellow-500 font-bold'>{hourStats[0] !== undefined ? hourStats[0].b : '...'}</span>
        </div>
        <div className='bg-white p-4 rounded-md'>
          <p>TOTAL DAILY CONSUMPTION</p>
          <span className='text-yellow-500 font-bold'>{dayStats[0] ? dayStats[0].b : '...'}</span>
        </div>
        <div className='bg-white p-4 rounded-md'>
          <p>CURRENT MONTH CONSUMPTION</p>
          <span className='text-yellow-500 font-bold'>{monthStats[0] ? monthStats[0].b : '...'}</span>
        </div>
      </div>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2'>
        <div className='bg-white p-4 rounded-md' >
          <span><u><b>Usage per day</b></u></span>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={dayStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="a" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="b" stroke="#8884d8" />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className='bg-white p-4 rounded-md'>
          <span><u><b>Usage per month</b></u></span>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={monthStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="a" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="b" stroke="#8884d8" />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className='bg-white p-4 rounded-md'>
          <span><u><b>Usage per hour</b></u></span>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={hourStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="a" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="b" stroke="#8884d8" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  )
}
  
export default Utilization
  